import React from "react";
// @ts-ignore
import Picture from "react-picture-component";
import {
    Desktop,
    Mobile,
    Tablet,
    getDesktopBreakpoint,
    getTabletBreakpoint,
    getMobileBreakpoint
} from "../../utils/BannerUtil";
import FeatureUtil from "../../utils/FeatureUtil";

type Props = {
    className?: string;
    images: any;
    alt?: string;
};

export class Ad extends React.Component<Props> {
    blockGifs = FeatureUtil.shouldUseBlockGifs();

    componentDidMount() {
        // Ugly hack: IE has a problem of switching from the default banner image to the finally loaded correct one.
        // To trigger the switch we need to trigger a resize event. Since IE doesn't have the type 'Event', the
        // following code is executed
        if (this.isInternetExplorer11()) {
            const evt = new UIEvent("resize", { bubbles: true, cancelable: false });
            window.dispatchEvent(evt);
        }
    }

    isInternetExplorer11 = () => {
        // @ts-ignore
        return !!window.MSInputMethodContext && !!document.documentMode;
    };

    // Hack to make sure IE will render the image correctly when the page is loaded
    // It was not possible to use the element picture even when added the correct polyfill
    renderImageForInternetExplorer(bannerImage: string) {
        const className = "mfcss_advertisement " + (this.props.className || "");
        let image = bannerImage;
        if (this.blockGifs) {
            image = bannerImage + "?format=jpg&quality=80&dpi=72";
        }
        const style: any = { backgroundImage: 'url("' + image + '")', "background-size": "100% 100%" };
        return (
            <div className={className} style={style}>
                <img alt={this.props.alt || "ad"} src={image} style={{ visibility: "hidden" }} />
            </div>
        );
    }

    renderForInternetExplorer() {
        const imageDesktop = this.props.images[0][getDesktopBreakpoint()];
        const imageTablet = this.props.images[0][getTabletBreakpoint()]
            ? this.props.images[0][getTabletBreakpoint()]
            : imageDesktop;
        const imageMobile = this.props.images[0][getMobileBreakpoint()]
            ? this.props.images[0][getMobileBreakpoint()]
            : imageTablet;

        return (
            <div>
                <Desktop>{this.renderImageForInternetExplorer(imageDesktop)}</Desktop>
                <Tablet>{this.renderImageForInternetExplorer(imageTablet)}</Tablet>
                <Mobile>{this.renderImageForInternetExplorer(imageMobile)}</Mobile>
            </div>
        );
    }

    render() {
        if (this.isInternetExplorer11()) {
            return this.renderForInternetExplorer();
        }

        const imageList = this.props.images[0];
        if (this.blockGifs) {
            Object.keys(imageList).forEach(key => {
                imageList[key] += "?format=jpg&quality=80&dpi=72";
            });
        }

        return (
            <Picture
                images={imageList}
                alt={this.props.alt || "ad"}
                className={"mfcss_advertisement " + (this.props.className || "")}
            />
        );
    }
}
